module.exports = __webpack_public_path__ + "static/img/layaair-logo-black.c6f6a423.png";